import { t } from '@lingui/core/macro';
import { Chip, ChipAction, Sidebar, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function DocumentIdChip(props) {
    const { id } = props;
    const { addToast } = useToast();
    const copyToClipboard = () => {
        navigator.clipboard.writeText(id).then(() => {
            addToast({
                appearance: 'success',
                title: t({
                    message: 'Copied ID to clipboard',
                    comment: 'Copy ID to clipboard toast success message',
                }),
            });
        });
    };
    return (<Sidebar.DefinitionItem term={t({ message: 'Document id', comment: 'Label for document id' })}>
      <Sidebar.Definition>
        <Chip size="small" secondary={id} appearance="secondary" action={<ChipAction onClick={copyToClipboard}>
              <Falcon icon="copy"/>
            </ChipAction>}/>
      </Sidebar.Definition>
    </Sidebar.DefinitionItem>);
}
